import * as React from 'react';
import NotificationBanner from 'components/Notification';
import { Link, Typography } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useLocation } from 'react-router';

function HotelNotificationPopup(): JSX.Element {
  return (
    <Typography>Are you experiencing issues when you go to book your Kimpton Marlow hotel room?
      Did you already book and you an alert such as 'the rate was no longer available'? <br /> 
      <br /> 
      Never Fear! Court is here! (You know he loves figuring out hotel stuff. Actually no joke...) <br/>
      <br/>
      Reach out to Court directly via text or email:
      {/* { <ul> */}
         {/* <li><Link href='tel:+1XXX-XXX-XXXX'>XXX-XXX-XXX</Link></li> */}
         {/* <li><Link href='mailto: XXXXXXX@gmail.com'>XXXXXXXX@gmail.com</Link></li> */}
        {/* </ul>} */}
    </Typography>
  );
}

 export default function HotelNotification() {
  const location = useLocation();
  const isVisible = !location.pathname.startsWith("/hotels")
  return (
    <>
    { isVisible ?
    <NotificationBanner>
      Need to book accomodations? Please see important info <Link href="/hotels" underline='always' sx={(theme) => ({color: theme.palette.grey[300]})}>HERE <OpenInNewIcon fontSize="small" sx={{verticalAlign: "middle"}}/></Link>
    </NotificationBanner>
    : <></> }
    </>
  );
}
